<template>
    <page>
        <module enable-flex>
            <view-list ref="view" :work-type="12">
                <template #search>
                    <m-search ref="search">
                        <m-search-item label="背贴码">
                            <m-code-batch-input name="produce_codes" field-name="背贴码"></m-code-batch-input>
                        </m-search-item>
                        <m-search-item label="IMEI">
                            <m-code-batch-input name="imeis" field-name="IMEI"></m-code-batch-input>
                        </m-search-item>
                        <m-search-item label="商户">
                            <c-select name="merchant_id" async @search="searchMerchant"></c-select>
                        </m-search-item>
                        <m-search-item label="商户名称">
                            <c-input name="merchant_name" placeholder="支持模糊查询"></c-input>
                        </m-search-item>
                        <m-search-item label="订单号">
                            <c-input name="keyword" placeholder="销售单号/三方订单号"></c-input>
                        </m-search-item>
                        <m-search-item label="商品名称">
                            <c-input name="product_name"></c-input>
                        </m-search-item>
                        <m-search-item label="售卖类型">
                            <c-select name="sell_type" :options="SALE_SELL_TYPE"></c-select>
                        </m-search-item>
                        <m-search-item label="销售渠道">
                            <c-select name="channel_id" async @search="searchChannel"></c-select>
                        </m-search-item>
                        <m-search-item label="创建时间" colspan="2">
                            <c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
                        </m-search-item>
                    </m-search>
                </template>

                <c-table-column type="button" label="操作" width="260" fixed="right">
                    <template #default="{data}">
                        <c-table-button icon="tf-detail" @click="$refs.detail.open(data)">详情</c-table-button>
                        <c-table-button icon="tf-detail" @click="viewQualityReport(data)">质检报告</c-table-button>
                        <!--拒绝发货：按订单状态判断，仅待发货（order_state=2）可拒绝，发货/取消/完成后状态自然不可达；
                            渠道上目前仅转转（platform_code=ZZ）支持，后端 refuseOnlineOrder 同样按订单状态+ZZ 双重拦截-->
                        <c-table-button v-if="auth('b_ops_order_refuse_ship') && data.order_state == 2 && data.platform_code == 'ZZ'" icon="tf-reject" color="red" @click="openRefuseDialog(data)">拒绝发货</c-table-button>
                        <!--标记异常：仅待发货且未标记过的订单；恢复正常：仅待发货且已标记异常的订单-->
                        <c-table-button v-if="auth('b_ops_order_abnormal_mark') && data.order_state == 2 && data.abnormal_flag != 1" icon="tf-edit" color="red" @click="openMarkDialog(data)">标记异常</c-table-button>
                        <c-table-button v-if="auth('b_ops_order_abnormal_restore') && data.order_state == 2 && data.abnormal_flag == 1" icon="tf-cancel" color="green" @click="restoreAbnormal(data)">恢复正常</c-table-button>
                        <!--取消订单：待收款直接可取消；待发货已收款，业务要求先标记异常才能取消（标记后按钮自然出现）；自营会退款，三方只做强制关单+释放锁-->
                        <c-table-button v-if="auth('b_ops_order_close') && (data.order_state == 1 || (data.order_state == 2 && data.abnormal_flag == 1))" icon="tf-cancel" color="red" @click="openCloseDialog(data)">取消订单</c-table-button>
                        <!--申请售后：仅待收货/已完成状态且无任意状态历史售后单的订单可申请售后-->
                        <c-table-button v-if="auth('b_ops_order_apply_after_sale') && data.can_apply_after_sale == 1" icon="tf-add" color="red" @click="openAfterSaleDialog(data)">申请售后</c-table-button>
                    </template>
                </c-table-column>

                <template #saas_info="{data}">
                    <div class="m-saas-info">
                        <p>{{data.saas_id || '-'}}</p>
                        <p class="m-saas-info-name">{{data.saas_name || '-'}}</p>
                    </div>
                </template>

                <template #product_info="{data}">
                    <m-product-info :name="getProductText(data)" :level="data.level_type" :code="data.produce_code" :imei="data.imei"></m-product-info>
                </template>

                <template #produce_code="{data}">
                    {{data.produce_code}} <c-link v-if="data.produce_code" color="gray" @click="$copy(data.produce_code)"><i class="tf">&#xe6b0;</i></c-link>
                </template>

                <template #imei="{data}">
                    {{data.imei}} <c-link v-if="data.imei" color="gray" @click="$copy(data.imei)"><i class="tf">&#xe6b0;</i></c-link>
                </template>

                <template #sell_type="{data}">
                    <c-state async dict="SALE_SELL_TYPE" tag :value="data.sell_type"></c-state>
                </template>

                <template #order_state="{data}">
                    <c-state async dict="SALES_ORDER_STATE" tag :value="getOrderDisplayState(data)"></c-state>
                    <!--异常关单不是订单主状态：状态照常显示，旁边挂红圈感叹号，悬停看运营填的异常备注-->
                    <c-tooltip v-if="data.abnormal_flag == 1" :tip="'异常关单：不可发货' + (data.abnormal_remark ? '。原因：' + data.abnormal_remark : '')"><span class="m-abnormal-help">!</span></c-tooltip>
                </template>

                <template #order_info="{data}">
                    <div class="m-product-info">
                        <p>销售单号：{{data.order_no || '-'}}</p>
                        <p class="m-product-info-code">三方订单号：{{data.third_party_order_no || data.order_no || '-'}}</p>
                        <p v-if="data.third_party_quality_code" class="m-product-info-code">三方质检码：{{data.third_party_quality_code}}</p>
                    </div>
                </template>

                <template #ship_overdue_flag="{data}">
                    <span v-if="data.is_overdue_ship == 1" style="color: #e53e3e;">超期</span>
                    <span v-else>-</span>
                </template>

                <template #settle_state="{data}">
                    <c-state async dict="SALE_SETTLE_STATE" tag :value="data.settle_state"></c-state>
                </template>

                <template #sale_price="{data}">
                    <span style="color: #e53e3e;">{{formatPrice(data.sale_price)}}</span>
                </template>

                <template #cost_price="{data}">
                    {{formatPrice(data.cost_price)}}
                </template>

                <template #refund_info="{data}">
                    <span v-if="!Number(data.refund_amount)">-</span>
                    <div v-else class="m-product-info">
                        <p style="color: #e53e3e;">{{formatPrice(data.refund_amount)}}</p>
                        <p class="m-product-info-code">{{data.refund_date || '-'}}</p>
                    </div>
                </template>

                <template #receiver_info="{data}">
                    <div class="m-product-info">
                        <p v-if="data.receiver_name">{{data.receiver_name}}（{{data.receiver_phone}}）</p>
                        <p v-if="data.receiver_address" class="m-product-info-code">{{data.receiver_address}}</p>
                        <p v-if="!data.receiver_name && !data.receiver_address">-</p>
                    </div>
                </template>

                <template #create_user_id="{data}">
                    {{data.create_user_realname || '-'}}
                </template>
            </view-list>
            <!--标记异常弹框：备注必填，标记后商户不能发货-->
            <c-dialog ref="markDialog" title="标记异常关单" width="520">
                <!--带底部按钮区的 c-dialog 内容区四边内边距为 0，需自己包一层加留白（同超卖处理弹框 .m-content 的写法）-->
                <div class="m-mark-body">
                    <div class="m-mark-tip">
                        确认将订单【{{markingRow.order_no}}】标记为异常关单吗？标记后商户不能发货，资金退回需在渠道侧手动处理。
                    </div>
                    <div class="m-mark-remark">
                        <p class="m-mark-remark-label">异常备注</p>
                        <!--组件库 textarea 不认 rows 属性，行数用 height-resize 控制（同下架异常处理弹框的写法）-->
                        <c-input v-model="abnormalRemark" type="textarea" maxlength="500" :height-resize="{minHeight: '90px'}" placeholder="请填写异常原因及处理方式（必填）"></c-input>
                    </div>
                </div>
                <template #button>
                    <c-button size="dialog" color="main" :disabled="isSubmitting" @click="submitMark">确认标记</c-button>
                    <c-button size="dialog" :disabled="isSubmitting" @click="$refs.markDialog.close()">取消</c-button>
                </template>
            </c-dialog>
            <!--取消订单弹框：原因必填；自营会原路退款+释放锁，三方只做强制关单+释放锁不退款-->
            <c-dialog ref="closeDialog" title="取消订单" width="520">
                <div class="m-mark-body">
                    <div class="m-mark-tip" v-if="closingRow.channel_owner_type == 1">
                        确认关闭自营渠道订单【{{closingRow.order_no}}】吗？关闭后订单置为已取消、不可恢复，已付款订单会原路退款并释放商品占用。
                    </div>
                    <div class="m-mark-tip m-mark-tip-warn" v-else>
                        确认强制取消三方渠道订单【{{closingRow.order_no}}】吗？此操作仅修正本地订单状态并释放同售锁，<b>不会触发渠道侧退款</b>，请与渠道确认已处理退款后再操作。
                    </div>
                    <div class="m-mark-remark">
                        <p class="m-mark-remark-label">取消原因（必填）</p>
                        <c-input v-model="closeRemark" type="textarea" maxlength="500" :height-resize="{minHeight: '90px'}" placeholder="请填写取消原因，供后续核对"></c-input>
                    </div>
                </div>
                <template #button>
                    <c-button size="dialog" color="red" :disabled="isSubmitting" @click="submitClose">确认取消</c-button>
                    <c-button size="dialog" :disabled="isSubmitting" @click="$refs.closeDialog.close()">再想想</c-button>
                </template>
            </c-dialog>
            <!--拒绝发货弹框（入口自商户端迁移，仅转转渠道）：类型必选取字典 REFUSE_SHIP_TYPE（码值与转转 reasonType 一一对齐），原因选填；
                提交后回推转转拒绝发货，并同取消订单一样处理：本地订单置已取消、释放商品同售占用，退款由渠道侧处理-->
            <c-dialog ref="refuseDialog" title="拒绝发货" width="700">
                <div class="m-mark-body">
                    <div class="m-mark-tip m-mark-tip-warn">
                        确认拒绝发货吗？拒绝后将通知转转渠道关单，本地订单同步取消并释放商品同售占用，<b>不可恢复</b>，退款由渠道侧处理。
                    </div>
                    <div class="m-mark-tip">
                        订单【{{refusingRow.order_no}}】：{{refusingRow.product_name || '-'}}
                        <template v-if="refusingRow.produce_code">｜背贴码：{{refusingRow.produce_code}}</template>
                        <template v-if="refusingRow.channel_name">｜销售渠道：{{refusingRow.channel_name}}</template>
                        ｜三方订单号：{{refusingRow.third_party_order_no || refusingRow.order_no}}
                    </div>
                    <div class="m-refuse-item">
                        <p class="m-mark-remark-label"><span class="m-required">*</span>拒绝发货类型</p>
                        <c-select v-model="refuseType" :options="REFUSE_SHIP_TYPE" placeholder="请选择"></c-select>
                    </div>
                    <div class="m-refuse-item">
                        <p class="m-mark-remark-label">拒绝原因</p>
                        <c-input v-model="refuseReason" placeholder="请输入拒绝原因"></c-input>
                    </div>
                </div>
                <template #button>
                    <c-button size="dialog" color="red" :disabled="isSubmitting" @click="submitRefuse">确定拒绝</c-button>
                    <c-button size="dialog" :disabled="isSubmitting" @click="$refs.refuseDialog.close()">取消</c-button>
                </template>
            </c-dialog>
            <!--售后补录弹框：只建一张待审核退机单，退款资金由渠道侧处理-->
            <c-dialog ref="afterSaleDialog" title="申请售后" width="800">
                <div class="m-mark-body">
                    <div class="m-mark-tip m-mark-tip-warn">
                        仅用于渠道侧已完成售后退机，但本地无售后单，无法退机恢复在售场景。
                    </div>
                    <div class="m-mark-tip">
                        订单【{{afterSaleRow.order_no}}】：{{getProductText(afterSaleRow)}}
                        <template v-if="afterSaleRow.produce_code">｜背贴码：{{afterSaleRow.produce_code}}</template>
                        <template v-if="afterSaleRow.channel_name">｜销售渠道：{{afterSaleRow.channel_name}}</template>
                        <template v-if="afterSaleRow.saas_name">｜商户：{{afterSaleRow.saas_name}}</template>
                        ｜三方订单号：{{afterSaleRow.third_party_order_no || afterSaleRow.order_no}}
                    </div>
                    <div class="m-refuse-item">
                        <p class="m-mark-remark-label">退机金额（元）</p>
                        <p class="m-mark-sub-tip">{{formatPrice(afterSaleAmount)}}，按订单商品销售价全额退机，不可修改</p>
                    </div>
                    <div class="m-refuse-item">
                        <p class="m-mark-remark-label"><span class="m-required">*</span>售后原因</p>
                        <c-input v-model="afterSaleReason" type="textarea" maxlength="500" :height-resize="{minHeight: '90px'}" placeholder="请填写原因（必填）"></c-input>
                    </div>
                    <div class="m-refuse-item">
                        <p class="m-mark-remark-label">凭证</p>
                        <c-upload-file filePath="quote" name="after_image" v-model="afterSaleImage" type="image" media button="请选择图片"></c-upload-file>
                    </div>
                </div>
                <template #button>
                    <c-button size="dialog" color="main" :disabled="isSubmitting" @click="submitAfterSale">确认</c-button>
                    <c-button size="dialog" :disabled="isSubmitting" @click="$refs.afterSaleDialog.close()">取消</c-button>
                </template>
            </c-dialog>
            <erp-order-detail ref="detail" :order-type="2"></erp-order-detail>
            <quality-report-view ref="qualityReport"></quality-report-view>
        </module>
    </page>
</template>

<script>
import ErpOrderDetail from './components/order_detail.vue';
import QualityReportView from './components/quality_report_view.vue';
import {asyncMapState} from '@/store';

export default {
    name: 'erp_online_order',
    components: {ErpOrderDetail, QualityReportView},
    computed: {
        ...asyncMapState(['SALE_SELL_TYPE', 'REFUSE_SHIP_TYPE'])
    },
    data() {
        return {
            markingRow: {},//正在标记的订单行
            abnormalRemark: '',//异常备注
            closingRow: {},//正在关闭的订单行
            closeRemark: '',//关闭原因
            refusingRow: {},//正在拒绝发货的订单行
            refuseType: '',//拒绝发货类型（字典 REFUSE_SHIP_TYPE）
            refuseReason: '',//拒绝发货原因
            afterSaleRow: {},//正在补录售后的订单行
            afterSaleAmount: 0,//退机金额（固定取订单明细销售价）
            afterSaleReason: '',//补录售后原因
            afterSaleImage: '',//补录凭证图URL（选填）
            isSubmitting: false//防止重复提交
        }
    },
    methods: {
        searchMerchant(keyword, resolve) {
            this.request({url: '/sys_saas/options', data: {keyword}, success: resolve});
        },
        /*********质检报告：订单行下发条码ID/背贴码，弹窗按商户切租户查询**********/
        viewQualityReport(data) {
            this.$refs.qualityReport.open(Object.assign({}, data, {
                product_code_id: data.product_unique_code_id,
                produce_unique_code: data.produce_code
            }));
        },
        /*********搜索销售渠道**********/
        searchChannel(keyword, resolve) {
            this.request({
                url: '/sale/product/channel/options',
                data: {keyword},
                success: data => {
                    resolve((data || []).map(item => {
                        return {
                            name: item.channel_name,
                            value: item.channel_id
                        };
                    }));
                }
            });
        },
        // 统一显示状态；业务操作仍使用原始 order_state
        getOrderDisplayState(data) {
            const displayState = Number(data.display_state);
            // 后端 fillListLookupData 的结果：9售后中、10补差完成、11退机完成；异常关单不在其中，状态列直接看 abnormal_flag。
            if (Number.isInteger(displayState) && displayState >= 1 && displayState <= 11) {
                return displayState;
            }
            // 兼容尚未返回 display_state 的接口；现有字段无法判断售后状态。
            const orderState = Number(data.order_state);
            if (orderState === 2 && Number(data.is_overdue_ship) === 1) return 6;
            if (orderState === 4) {
                if (data.settle_state === 0 || data.settle_state === '0') return 7;
                if (data.settle_state === 1 || data.settle_state === '1') return 8;
            }
            return data.order_state;
        },
        formatPrice(price) {
            if (price === null || price === undefined || price === '') return '-';
            return '¥' + parseFloat(price).toFixed(2);
        },
        getProductText(data) {
            var parts = [];
            if (data.brand_name) parts.push(data.brand_name);
            if (data.model_name) parts.push(data.model_name);
            if (data.memory_name) parts.push(data.memory_name);
            if (data.color_name) parts.push(data.color_name);
            return parts.join(' ') || '-';
        },
        /*********标记异常：打开备注弹框**********/
        openMarkDialog(data) {
            this.markingRow = data;
            this.abnormalRemark = '';
            this.$refs.markDialog.open();
        },
        /*********提交标记异常**********/
        submitMark() {
            if (this.isSubmitting) return;
            if (!this.abnormalRemark.trim()) {
                this.$message({message: '请填写异常备注', type: 'warn'});
                return;
            }
            this.isSubmitting = true;
            this.request({
                url: '/online/sale/order/ops/abnormal',
                data: {
                    merchant_id: this.markingRow.saas_id,
                    order_id: this.markingRow.order_id,
                    remark: this.abnormalRemark.trim()
                },
                loading: true,
                success: (data, msg) => {
                    this.$refs.markDialog.close();
                    this.$message({message: msg || '标记异常成功', type: 'success'});
                    this.$refs.view.update();
                },
                complete: () => {
                    this.isSubmitting = false;
                }
            });
        },
        /*********关闭订单：打开原因弹框**********/
        openCloseDialog(data) {
            this.closingRow = data;
            this.closeRemark = '';
            this.$refs.closeDialog.open();
        },
        /*********提交关闭订单**********/
        submitClose() {
            if (this.isSubmitting) return;
            if (!this.closeRemark.trim()) {
                this.$message({message: '请填写关闭原因', type: 'warn'});
                return;
            }
            this.isSubmitting = true;
            this.request({
                url: '/sale/order/ops/cancel',
                data: {
                    merchant_id: this.closingRow.saas_id,
                    order_id: this.closingRow.order_id,
                    remark: this.closeRemark.trim()
                },
                loading: true,
                success: (data, msg) => {
                    this.$refs.closeDialog.close();
                    this.$message({message: msg || '关闭订单成功', type: 'success'});
                    this.$refs.view.update();
                },
                complete: () => {
                    this.isSubmitting = false;
                }
            });
        },
        /*********拒绝发货：打开弹框**********/
        openRefuseDialog(data) {
            this.refusingRow = data;
            this.refuseType = '';
            this.refuseReason = '';
            this.$refs.refuseDialog.open();
        },
        /*********提交拒绝发货**********/
        submitRefuse() {
            if (this.isSubmitting) return;
            if (!this.refuseType) {
                this.$message({message: '请选择拒绝发货类型', type: 'warn'});
                return;
            }
            this.isSubmitting = true;
            this.request({
                url: '/online/sale/order/ops/refuse_ship',
                data: {
                    merchant_id: this.refusingRow.saas_id,
                    order_id: this.refusingRow.order_id,
                    refuse_type: this.refuseType,
                    refuse_reason: this.refuseReason.trim()
                },
                loading: true,
                success: (data, msg) => {
                    this.$refs.refuseDialog.close();
                    this.$message({message: msg || '拒绝发货成功', type: 'success'});
                    this.$refs.view.update();
                },
                complete: () => {
                    this.isSubmitting = false;
                }
            });
        },
        /*********售后补录：打开弹框（行数据是订单明细维度，id 即 order_product_id）**********/
        openAfterSaleDialog(data) {
            this.afterSaleRow = data;
            this.afterSaleAmount = parseFloat(data.sale_price) || 0;
            this.afterSaleReason = '';
            this.afterSaleImage = '';
            this.$refs.afterSaleDialog.open();
        },
        /*********提交售后补录：merchant_id 只用于圈定查单范围，落库 saas_id 由服务端按订单行反查**********/
        submitAfterSale() {
            if (this.isSubmitting) return;
            if (!this.afterSaleReason.trim()) {
                this.$message({message: '请填写售后原因', type: 'warn'});
                return;
            }
            this.isSubmitting = true;
            this.request({
                url: '/aftersale/ops/create',
                data: {
                    merchant_id: this.afterSaleRow.saas_id,
                    order_id: this.afterSaleRow.order_id,
                    order_product_id: this.afterSaleRow.id,
                    refund_reason: this.afterSaleReason.trim(),
                    after_image: this.afterSaleImage
                },
                loading: true,
                success: (data, msg) => {
                    this.$refs.afterSaleDialog.close();
                    this.$message({message: msg || '售后补录成功', type: 'success'});
                    this.$refs.view.update();
                },
                complete: () => {
                    this.isSubmitting = false;
                }
            });
        },
        /*********恢复正常：二次确认后提交**********/
        restoreAbnormal(data) {
            this.$confirm({
                message: '确认将订单【' + data.order_no + '】恢复正常吗？恢复后商户可再次发货',
                buttonName: '确认恢复',
                cancelButton: true,
                resolve: () => {
                    this.request({
                        url: '/online/sale/order/ops/abnormal/restore',
                        data: {
                            merchant_id: data.saas_id,
                            order_id: data.order_id
                        },
                        loading: true,
                        success: (data, msg) => {
                            this.$message({message: msg || '恢复正常成功', type: 'success'});
                            this.$refs.view.update();
                        }
                    });
                }
            });
        }
    }
};
</script>

<style scoped>
.m-product-info {line-height: 24px; font-size: 13px; color: #333;}
.m-product-info p {margin: 0;}
.m-saas-info {line-height: 20px; font-size: 13px; color: #333;}
.m-saas-info p {margin: 0;}
.m-saas-info-name {color: #999; font-size: 12px;}
.m-mark-body {padding: 20px 24px;}
.m-mark-tip {margin-bottom: 12px; padding: 10px 12px; background: #fff7e6; border: 1px solid #ffe7ba; border-radius: 4px; font-size: 13px; line-height: 20px; color: #333;}
.m-mark-tip-warn {background: #fff5f5; border-color: #fed7d7;}
.m-mark-remark-label {margin-bottom: 8px; font-size: 13px; font-weight: bold; color: #333;}
.m-mark-sub-tip {margin-top: 6px; font-size: 12px; color: #999;}
.m-refuse-item {margin-bottom: 16px;}
.m-required {color: #e53e3e; margin-right: 2px;}
/* 状态列旁的异常关单红圈感叹号：与商品信息行“原IMEI”提示（.m-help）同款写法，配色取异常红 */
.m-abnormal-help {display: inline-flex; align-items: center; justify-content: center; width: 14px; height: 14px; margin-left: 4px; border: 1px solid #e53e3e; border-radius: 50%; font-size: 10px; color: #e53e3e; cursor: pointer; vertical-align: middle;}
</style>
